import { useFormContext } from 'react-hook-form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select.tsx';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form.tsx';
import { Input } from '@/components/ui/input.tsx';
import { Textarea } from '@/components/ui/textarea.tsx';
import { TPlant } from '@/features/plants/schemas/plants.schema.ts';

export const PlantFormStepBasicDetails = ({ showTitle = false }: { showTitle?: boolean }) => {
  const form = useFormContext<TPlant>();

  return (
    <div id="basicDetails" className="space-y-4 rounded-lg bg-white p-4 py-4 pb-8">
      {showTitle && <h3 className="font-semibold">Basic Details</h3>}
      <FormField
        control={form.control}
        name="basicDetails.name"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="required">Plant name</FormLabel>
            <FormControl>
              <Input className="bg-white" placeholder="Enter the plant name" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="basicDetails.type"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="required">Plant type</FormLabel>
            <FormControl>
              <Select onValueChange={field.onChange} value={field.value}>
                <SelectTrigger className="bg-white">
                  <SelectValue placeholder="Select a plant type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Residential">Residential</SelectItem>
                  <SelectItem value="C&I">C&I</SelectItem>
                  <SelectItem value="Utility-scale PV plant">
                    Utility-scale PV plant
                  </SelectItem>
                </SelectContent>
              </Select>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="technicalSpecifications.setupType"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="required">Plant setup type</FormLabel>
            <FormControl>
              <Select onValueChange={field.onChange} value={field.value}>
                <SelectTrigger className="bg-white">
                  <SelectValue placeholder="Select a plant type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="production-storage">Production and Storage</SelectItem>
                  <SelectItem value="production-only">Production only</SelectItem>
                  <SelectItem value="storage-only">Storage only</SelectItem>
                </SelectContent>
              </Select>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="basicDetails.status"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="required">Plant status</FormLabel>
            <FormControl>
              <Select onValueChange={field.onChange} value={field.value}>
                <SelectTrigger className="bg-white">
                  <SelectValue placeholder="Select a plant status" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Operational">Operational</SelectItem>
                  <SelectItem value="Planning">Planning</SelectItem>
                  <SelectItem value="Under Construction">Under Construction</SelectItem>
                  <SelectItem value="Maintenance">Maintenance</SelectItem>
                  <SelectItem value="Archived">Archived</SelectItem>
                </SelectContent>
              </Select>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="basicDetails.shortDescription"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Short description</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Write a short description about the plant"
                className="resize-none bg-white"
                {...field}
                value={field.value ?? ''}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
